<div class="dx-search">
    <div class="dx-search-row" *ngIf="!es.isClosed">
        <span class="dx-search-label">Diagnosis Shortcut</span>
        <div class="dx-search-box">
            <input class="t-field t-field--limitRad t-field-pad dx-search-input" type="text" autocomplete="off" [(ngModel)]="query" [placeholder]="placeholder" (keydown.enter)="addFirst(); $event.preventDefault()" />
            <ul class="dx-search-results" *ngIf="results.length">
                <li *ngFor="let r of results" (mousedown)="add(r[2])">{{r[2]}}</li>
            </ul>
        </div>
    </div>
    <div class="dx-search-selected" *ngIf="selected.length">
        <div class="dx-search-item" *ngFor="let line of selected; let i = index" (dblclick)="remove(i)" title="Double clicking on this will remove it">{{line}}</div>
    </div>
</div>
